export default __webpack_public_path__ + "static/media/stone-ballast-rail.16ab620c.png";